// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Tvqo5","secWrpr":"Login_secWrpr__v-slO","label":"Login_label__RePbh"};